export default __webpack_public_path__ + "static/image1-0c410162d198f894f8d06d07d420b202.png";